import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import '../../Styles/Header.css'
import Appbar from '../../Component/NavPannel/Appbar';
import CreateKycRoutes from './../../Component/Layouts/CreateKyc';


const mdTheme = createTheme();

function KYC() {
 
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <div className='sidebarsetting' >
        <Appbar mainpage="Home" subpage="KYC"/>
          </div>
        <CreateKycRoutes />
      </Box>
    </ThemeProvider>
  );
}

export default function MainKyc() {
  return <KYC />
}